import { MediaImage, MediaSize } from "../types/MediaImage";
import logger from "./logger";

export function getMediaImage(image: MediaImage, size?: MediaSize): string {
  try {
    if (image) {
      if (size !== undefined) {
        const selectedImage = image.node.mediaDetails.sizes.find(
          (img) => img.name == size
        );

        if (selectedImage) {
          return selectedImage.sourceUrl;
        } else {
          return image.node.mediaDetails.sizes[0].sourceUrl;
        }
      }
      return image.node.sourceUrl;
    }
    throw new Error(
      "Post não contém imagem de destaque, inserindo imagem genérica"
    );
  } catch (error: unknown) {
    logger.warn("Image not found", error as Error);
    return "/static-next/generic-cover.png";
  }
}
